import React from "react";
import { Loader2 } from "lucide-react";

export const Label = ({ children }) => (
  <label className="block text-[11px] uppercase tracking-[0.2em] text-[#4B5563] mb-1.5 font-headings">{children}</label>
);

const inputCls =
  "w-full bg-white border border-gray-300 focus:border-[#0A2463] focus:ring-2 focus:ring-[#0A2463]/10 outline-none px-3 py-2.5 text-[15px] text-[#0A192F] transition-colors";

export const Field = ({ label, children, className = "" }) => (
  <div className={className}>
    {label && <Label>{label}</Label>}
    {children}
  </div>
);

export const Input = (props) => <input {...props} className={`${inputCls} ${props.className || ""}`} />;
export const TextArea = (props) => <textarea rows={4} {...props} className={`${inputCls} ${props.className || ""}`} />;
export const Select = ({ options = [], placeholder, ...props }) => (
  <select {...props} className={`${inputCls} ${props.className || ""}`}>
    {placeholder !== undefined && <option value="">{placeholder}</option>}
    {options.map((o) => (typeof o === "string" ? <option key={o} value={o}>{o}</option> : <option key={o.value} value={o.value}>{o.label}</option>))}
  </select>
);

export const Btn = ({ children, variant = "primary", busy, className = "", ...props }) => {
  const v = {
    primary: "bg-[#0A2463] hover:bg-[#071a49] text-white border-[#0A2463]",
    gold: "bg-[#F5B400] hover:bg-[#d99f00] text-[#0A192F] border-[#F5B400]",
    ghost: "bg-white hover:bg-gray-50 text-[#0A192F] border-gray-300",
    danger: "bg-white hover:bg-red-50 text-red-700 border-red-300",
  }[variant];
  return (
    <button
      {...props}
      disabled={busy || props.disabled}
      className={`inline-flex items-center justify-center gap-2 px-4 py-2.5 border font-headings uppercase tracking-wide text-sm transition-colors disabled:opacity-50 ${v} ${className}`}
    >
      {busy && <Loader2 size={15} className="animate-spin" />}
      {children}
    </button>
  );
};

const ESTADO_STYLE = {
  pendiente: ["Pendiente", "bg-amber-100 text-amber-800 border-amber-300"],
  aprobado: ["Aprobado", "bg-emerald-100 text-emerald-800 border-emerald-300"],
  rechazado: ["Rechazado", "bg-red-100 text-red-800 border-red-300"],
  correcciones: ["Requiere correcciones", "bg-blue-100 text-blue-800 border-blue-300"],
  activo: ["Activo", "bg-emerald-100 text-emerald-800 border-emerald-300"],
  suspendido: ["Suspendido", "bg-red-100 text-red-800 border-red-300"],
};

export const EstadoBadge = ({ estado, testid }) => {
  const [l, c] = ESTADO_STYLE[estado] || [estado, "bg-gray-100 text-gray-700 border-gray-300"];
  return (
    <span data-testid={testid} className={`inline-block px-2 py-0.5 text-[11px] font-headings uppercase tracking-wider border ${c}`}>{l}</span>
  );
};

export const RecreacionBadge = () => (
  <span className="inline-block px-2 py-0.5 text-[10px] font-headings uppercase tracking-wider bg-purple-100 text-purple-800 border border-purple-300">
    Recreación digital
  </span>
);

export const Card = ({ title, actions, children, className = "", testid }) => (
  <div className={`bg-white border border-gray-200 p-5 sm:p-6 ${className}`} data-testid={testid}>
    {(title || actions) && (
      <div className="flex flex-wrap items-center justify-between gap-3 mb-5">
        {title && <h3 className="font-headings uppercase tracking-wide text-lg text-[#0A192F]">{title}</h3>}
        {actions}
      </div>
    )}
    {children}
  </div>
);

export const Empty = ({ children }) => (
  <div className="border border-dashed border-gray-300 bg-white p-10 text-center text-[#6B7280] text-sm">{children}</div>
);

export const Spinner = () => (
  <div className="py-12 flex justify-center text-[#0A2463]"><Loader2 className="animate-spin" /></div>
);
